import React from 'react';

interface SwitchProps {
  value: boolean;
  setValue: (isChecked: boolean) => void;
}

const SwitchButton: React.FC<SwitchProps> = ({ value, setValue }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.checked);
  };

  return (
    <label className="relative inline-block w-10 h-6">
      <input type="checkbox" className="opacity-0 w-0 h-0" checked={value} onChange={handleChange} />
      <span className={`absolute cursor-pointer inset-0 rounded-full transition-colors ease-in-out duration-200 ${value ? 'bg-leaf-green' : 'bg-gray-300'}`}>
        <span
          className={`transform transition ease-in-out duration-200 absolute left-1 top-1 bg-white w-4 h-4 rounded-full ${
            value ? 'translate-x-full border-green-500' : 'translate-x-0 border-gray-300'
          }`}
          style={{ transform: value ? 'translateX(1rem)' : 'translateX(0)' }}
        />
      </span>
    </label>
  );
};

export default SwitchButton;
